interface IGenderFilters {
  [key: string]: string[];
}

export const genderFilters: IGenderFilters = {
  Male: ['Male', 'M'],
  Female: ['Female', 'F'],
  'Non-binary': ['Non-binary', 'NB'],
};
